<template>
  <ul class="comment-image-list">
    <li
      v-for="(image, index) in imagesList"
      :key="index"
      class="comment-image-list__item"
    >
      <el-image
        :src="image.url"
        :preview-src-list="image.srcList"
        fit="contain"
      >
      </el-image>
    </li>
  </ul>
</template>

<script>
  export default {
    name: 'Gallery',
    props: {
      images: {
        type: Array
      }
    },
    computed: {
      imagesList() {
        return this.images.map(item => {
          return {
            url: item,
            srcList: this.images.map(item => item),
          };
        });
      },
    },
  };
</script>

<style>
  .comment-image-list {
    padding: 0;
    margin: 0;
    list-style: none;
    display: flex;
  }
  .comment-image-list__item {
    margin-right: 5px;
    width: 100px;
  }
</style>
